// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.entity-properties-name {
  width: 250px;
  max-width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/entity-common/ui/row-renderers/NameRenderer.less"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,eAAA;AACF","sourcesContent":[".entity-properties-name {\n  width: 250px;\n  max-width: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
